import AdminTextInput from 'components/atoms/adminTextInput';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import {useTheme} from 'contexts/ThemeContext';
import { GroupType } from 'models/Admin';
import React, {useEffect, useState} from 'react';
import {FlatList, ListRenderItemInfo, View, Text} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface GroupListProps {
  flatListData: GroupType[];
  onPressDelete: (id: string) => void;
  onPressEdit: (id: string) => void;
}

const GroupList = (props: GroupListProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const renderItem = (itemProps: ListRenderItemInfo<GroupType>) => {
    let itemStyle: object[] = [styles.item];
    let buttonColor: string = theme.colors.dirtyWhite;

    if (itemProps.index % 2 != 0) {
      itemStyle.push(styles.evenItem);
      buttonColor = theme.colors.white;
    }

   
    return (
      <View style={itemStyle}>
        <View style={styles.textContainer}>
          <Text style={styles.textStyle}>{itemProps.item.name}</Text>
        </View>
        <RectangleImageButton
          image={theme.images.grayPen}
          onPress={() => props.onPressEdit(itemProps.item.id)}
          fullImage={false}
          backgroundColor={buttonColor}
        />
        <RectangleImageButton
          image={theme.images.trashDark}
          onPress={() => props.onPressDelete(itemProps.item.id)}
          fullImage={false}
          backgroundColor={buttonColor}
        />
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <FlatList
        style={styles.flatList}
        renderItem={renderItem}
        data={props.flatListData}
      />
    </View>
  );
};

export default GroupList;
